import { CSSProperties, ReactNode, memo } from "react";
import { ThemeStyle } from "../../hooks/useTheme";

type StandardSectionContainerProps = {
  title: string | ReactNode;
  subtext: string | ReactNode;
  icon?: ReactNode;
  containerStyles?: CSSProperties;
  onPress?: () => void;
  iconOnPress?: () => void;
  theme?: ThemeStyle;
};

// The structure of this component
/**
 *  ____________________
 * | title              |
 * | subtext       icon |
 * |____________________|
 */
export const StandardSectionContainer = memo(
  function StandardSectionContainerFn(props: StandardSectionContainerProps) {
    const {
      title,
      subtext,
      icon,
      containerStyles,
      onPress,
      iconOnPress,
      theme,
    } = props;

    return (
      <div
        className="AlignedRowSpacedSelect"
        style={{ ...containerStyles, pointerEvents: !onPress ? "none" : "all" }}
        onClick={onPress}
      >
        <div
          className="ColumnNormalSelect"
          style={{ marginRight: 14, gap: 4, pointerEvents: "auto" }}
        >
          {typeof title === "string" ? (
            <span className="bodyMedium" style={{ ...theme?.PrimaryText }}>
              {title}
            </span>
          ) : (
            title
          )}
          <span className="smallBodySubtext" style={{ ...theme?.SubText }}>
            {subtext}
          </span>
        </div>
        {icon ? (
          <div
            style={{ cursor: "pointer", pointerEvents: "auto" }}
            onClick={iconOnPress}
          >
            {icon}
          </div>
        ) : null}
      </div>
    );
  }
);
